import { DISCOUNTS, FACILITY_AND_SPACE_FEATURES, FACILITY_INFO, LocationVarKey, URLS } from "@swivl-mono/types";

// Reverse lookup for value matches — the field label a location_variable's
// key belongs to. Built from the same catalogs each Details v3 page renders
// from, not a hand-maintained parallel list.
const LOCATION_VAR_KEY_LABELS: Partial<Record<LocationVarKey, string>> = {};

function register(key: LocationVarKey | undefined, label: string): void {
  if (key) LOCATION_VAR_KEY_LABELS[key] = label;
}

FACILITY_INFO.forEach((f) => {
  register(f.cortexVarKey, f.label);
  register(f.legacyKey, f.label);
});
FACILITY_AND_SPACE_FEATURES.forEach((f) => {
  register(f.cortexVarKey, f.label);
  register(f.nameVarKey, f.label);
  register(f.botWordingVarKey, f.label);
  register(f.legacyNameKey, f.label);
  register(f.legacyTextKey, f.label);
});
DISCOUNTS.forEach((d) => {
  register(d.detailsVarKey, d.label);
  register(d.nameVarKey, d.label);
  register(d.legacyDetailsKey, d.label);
  register(d.legacyNameKey, d.label);
});
URLS.forEach((u) => {
  register(u.urlVarKey, u.label);
  register(u.legacyURLKey, u.label);
});

export function findFieldLabelForVarKey(key: LocationVarKey): string | undefined {
  return LOCATION_VAR_KEY_LABELS[key];
}
